export default __webpack_public_path__ + "static/media/388.007a1eba.gif";